import React, { useEffect, useState } from "react"
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

// Build library of icons
library.add(fas)

// Helper
import { bodyRequest }      from '@helpers/javascript/javascript'

// Components
import { TodayOverview }   from './TodayOverview'
import { DailyWorkorders }  from './DailyWorkorders'
import { DailyStatus }      from './DailyStatus'
import { DailyTechTime }    from './DailyTechTime'
import { YearWorkorders }   from './YearWorkorders'

const Daily = props => {
  const {
    currentTeam,
    accountTeams,
    todayPath,
    workordersByYearPath,
    dailyDataPath,
    invoices,
    trackTime,
    initialTodayData,
    initialYearWorkorders,
    initialDailyData
  } = props

  const getDailyData = () => {
    const userIds = [...new Set(dailyUsers.map(u => u['id']))]
    bodyRequest({
      method: 'POST', url: dailyDataPath,
      body: { technicians: userIds, date: dailyDate.toString() }
    }).then(setDailyData)
  }

  // Today
  const [dailyUsers,      setDailyUsers]      = useState(currentTeam.values)
  const [dailyDate,       setDailyDate]       = useState(new Date())
  const [dailyWorkorders, setDailyWorkorders] = useState(initialDailyData ? initialDailyData.workorders : [])
  const [dailyStatus,     setDailyStatus]     = useState(initialDailyData ? initialDailyData.status : [])
  const [dailyTime,       setDailyTime]       = useState(initialDailyData ? initialDailyData.time : [])
  const [dailyData,       setDailyData]       = useState(initialDailyData || {status: [], time: [], workorders: []})
  const [initialLoad,     setInitialLoad]     = useState(!!initialDailyData)

  useEffect(() => {
    if (initialLoad) { setInitialLoad(false); return }
    getDailyData()
  }, [dailyUsers, dailyDate])

  useEffect(() => {
    setDailyStatus(dailyData.status)
    trackTime && setDailyTime(dailyData.time)
    setDailyWorkorders(dailyData.workorders)
  }, [dailyData])

  return (
    <>
      {/* Today's resume */}
      <TodayOverview
        url         = {todayPath}
        team        = {dailyUsers}
        invoices    = {invoices}
        initialData = {initialTodayData}
      />

      {/* Resume by year */}
      <YearWorkorders
        url               = {workordersByYearPath}
        users             = {dailyUsers}
        updateDate        = {setDailyDate}
        currentTeam       = {currentTeam}
        accountTeams      = {accountTeams}
        onChangeTeam      = {setDailyUsers}
        initialData       = {initialYearWorkorders}
      />

      <div className="dashboard__daily">
        <DailyStatus     data={dailyStatus} />
        <DailyWorkorders
          dailyDate ={dailyDate}
          updateDate={setDailyDate}
          workorders={dailyWorkorders}
          trackTime ={trackTime}
        />
      </div>

      { trackTime && <DailyTechTime data={dailyTime} />}
    </>
  )
}

export default Daily
